import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

export const DeleteMessageModal: React.FC<{
  onConfirm?: () => void;
  onCancel?: () => void;
}> = ({ onConfirm, onCancel }) => {
  const { t } = useTrans();
  return (
    <ModalContainer
      title={"library:deleteMessage"}
      onConfirmText="actions:confirm"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className="pt-3">
        <p>{t("library:areYouSureDeleteMessageHint")}</p>
      </div>
    </ModalContainer>
  );
};
